import { useState } from 'react';
import { addExtraHours } from '../../services/jobService';
import './AddExtraHoursModal.scss';

const MIN_RATE_PER_HOUR = 10;

function formatTime(t) {
  return t ? t.slice(0, 5) : '—';
}

function calculateNewEndTime(currentEndTime, hours) {
  if (!currentEndTime || !hours) return null;

  const [h, m] = currentEndTime.split(':').map(Number);
  const totalMinutes = h * 60 + m + Math.round(hours * 60);
  const newH = Math.floor(totalMinutes / 60) % 24;
  const newM = totalMinutes % 60;

  return `${String(newH).padStart(2, '0')}:${String(newM).padStart(2, '0')}`;
}

export default function AddExtraHoursModal({ job, jobId, onClose, onConfirm }) {
  const [hours, setHours] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const numericHours = parseFloat(hours.replace(',', '.'));
  const isValid = !isNaN(numericHours) && numericHours > 0;
  const newEndTime = isValid ? calculateNewEndTime(job.endTime, numericHours) : null;

  const handleSubmit = async () => {
    setError('');

    if (!isValid) {
      setError('Informe uma quantidade de horas válida (maior que zero).');
      return;
    }

    setLoading(true);
    try {
      const result = await addExtraHours(jobId, numericHours);
      onConfirm?.(result.endTime);
      onClose();
    } catch (err) {
      const msg = err?.response?.data || 'Erro ao adicionar horas extras.';
      setError(typeof msg === 'string' ? msg : 'Erro ao adicionar horas extras.');
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="aeh-overlay" onClick={onClose}>
      <div className="aeh-modal" onClick={(e) => e.stopPropagation()}>
        <button className="aeh-close" onClick={onClose} aria-label="Fechar">×</button>

        <div className="aeh-icon">⏱️</div>

        <h3 className="aeh-title">Adicionar Horas Extras</h3>
        <p className="aeh-subtitle">
          O turno será estendido. Valor mínimo por hora extra: R$ {MIN_RATE_PER_HOUR.toFixed(2).replace('.', ',')} (sem taxa da plataforma).
        </p>

        <div className="aeh-current">
          <span className="aeh-current-label">Horário atual do turno</span>
          <span className="aeh-current-value">
            {formatTime(job.startTime)} – {formatTime(job.endTime)}
          </span>
        </div>

        <div className="aeh-field">
          <label className="aeh-label">Quantas horas extras?</label>
          <input
            type="text"
            inputMode="decimal"
            className="aeh-input"
            placeholder="Ex: 1.5"
            value={hours}
            onChange={(e) => setHours(e.target.value.replace(/[^0-9.,]/g, ''))}
            disabled={loading}
          />
        </div>

        {isValid && newEndTime && (
          <div className="aeh-preview">
            <span className="aeh-preview-label">Novo horário de término</span>
            <span className="aeh-preview-value">{newEndTime}</span>
          </div>
        )}

        {error && <p className="aeh-error">{error}</p>}

        <div className="aeh-actions">
          <button className="aeh-btn aeh-btn--cancel" onClick={onClose} disabled={loading}>
            Cancelar
          </button>
          <button
            className="aeh-btn aeh-btn--confirm"
            onClick={handleSubmit}
            disabled={loading || !isValid}
          >
            {loading ? 'Salvando...' : 'Confirmar Horas Extras'}
          </button>
        </div>
      </div>
    </div>
  );
}